import { Component, OnInit } from '@angular/core';
import { IMyDpOptions } from 'mydatepicker';
import { RetailMessageService, SharedService, PrintingService, SessionService, RetailBalanceRpt } from 'baseline-lib';
import { CustomToast } from '../../shared/services/custom-toast';


@Component({
  selector: 'retail-balance-report',
  templateUrl: 'retail-balance-report.html'
})
export class RetailBalanceReportComponent {
  _error: any;
  _execptions: any;
  _gameIdList: any;
  sub: any;
  _fromDate: any;
  _toDate: any;
  _reportData: any[] = [];
  _printData: any;
  _clientValidation: any;
  myDatePickerOptions: IMyDpOptions = {
    inline: false,
    editableDateField: false,
  }
  p: number;

  constructor(
    private _sharedServices: SharedService,
    private _retailMessageServies: RetailMessageService,
    private _printingService: PrintingService,
    private _sessionService: SessionService,
    private toast: CustomToast

  ) {
    this._fromDate = this._toDate = { date: { year: this._sharedServices.getServerTime().getFullYear(), month: this._sharedServices.getServerTime().getMonth() + 1, day: this._sharedServices.getServerTime().getDate() }, jsdate: new Date() };
  }

  ngOnInit() {

  }
  validateRptDate(): Boolean {
    this._reportData = [];
    this._execptions = '';
    this._error = '';

    if (!this._fromDate || !this._toDate) {
      this._execptions = "Please select date."
      this.toast.showError(this._execptions);

      return false
    }
    if (this._fromDate.jsdate > this._toDate.jsdate) {
      this._execptions = 'To date should be greater than from date'
      this.toast.showError(this._execptions);

      setTimeout(() => {
        this._execptions = '';
      }, 3000);
      return false;
    }
    return true;
  }
  getReportData() {
    if (this.validateRptDate()) {
      let retBalRpt = new RetailBalanceRpt();
      let authuser = this._sessionService.getAuthUser()
      if (authuser) {
        this._sharedServices.showLoader();
        retBalRpt.tokenId = authuser.tokenNo;
        retBalRpt.id = null; // Need to add retailer id from session.    
        retBalRpt.fd = this._sharedServices.getFormatedDate(this._fromDate);
        retBalRpt.td = this._sharedServices.getFormatedDate(this._toDate);
        this._retailMessageServies.getBalanceRpt(retBalRpt)
          .subscribe(
          data => {
            this._sharedServices.hideLoader();
            if (data.balanceRepostList) {
              this._reportData = data.balanceRepostList;
            }
            else {
              this._execptions = data.msg
              this.toast.showError(this._execptions);

            }
          },
          error => {
            this._sharedServices.hideLoader();
            if (error.msg) {
              this._error = error.msg
            }
            else {
              this._error = error.message
            }
            this.toast.showError(this._error);

          }
          );
      }
    }
  }
  printReport() {
    // this._printData = "retailReport"
    // this._printingService.printDetails(this._printData);
    this._printingService.printRetailerReport();
  }

}




// WEBPACK FOOTER //
// ./src/app/retailer/retail-balance-report/retail-balance-report.ts